import { render, staticRenderFns } from "./PersonnelInfo.vue?vue&type=template&id=a4186848&scoped=true"
import script from "./PersonnelInfo.vue?vue&type=script&lang=js"
export * from "./PersonnelInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonnelInfo.vue?vue&type=style&index=0&id=a4186848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4186848",
  null
  
)

export default component.exports